import { Col, Form, Modal, Row } from 'react-bootstrap'
import { CustomButton } from '../../../components/CustomButton'
import { CheckCircleFill, XCircleFill } from 'react-bootstrap-icons'
import { toast } from 'react-toastify'
import apinode from '../../../services/apinode'
import { useState } from 'react'

export function ModalEditarInventario({ isOpen, inventory, onSave, onClose }) {
  const [editedInventory, setEditedInventory] = useState({ ...inventory })
  const [isRequestUpdateInventoryLoading, setIsRequestUpdateInventoryLoading] =
    useState(false)

  async function handleUpdateInventory() {
    try {
      setIsRequestUpdateInventoryLoading(true)

      await apinode.post(
        `inventario/inserirAtualizarParamInventario/${localStorage.idconta}`,
        editedInventory,
      )

      toast.success('Inventário atualizado com sucesso!')
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível atualizar o inventário!')
    } finally {
      setIsRequestUpdateInventoryLoading(false)
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setEditedInventory({ ...editedInventory, [name]: value })
  }

  const handleSave = async () => {
    await handleUpdateInventory()
    onSave(editedInventory)
  }

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      dialogClassName="custom-modalzpl"
    >
      <Modal.Header>
        <Modal.Title>Editar Inventário</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row>
          <Col xs={2}>
            <Form.Label>ID</Form.Label>

            <Form.Control
              name="ID"
              value={editedInventory.ID}
              onChange={handleChange}
              disabled
            />
          </Col>

          <Col>
            <Form.Label>DESCRIÇÃO</Form.Label>

            <Form.Control
              name="DESCRICAO"
              value={editedInventory.DESCRICAO}
              onChange={handleChange}
            />
          </Col>

          <Col xs={2}>
            <Form.Label>TIPO</Form.Label>

            <Form.Control
              className="mx-auto"
              name="TIPO"
              value={editedInventory.TIPO}
              onChange={handleChange}
            />
          </Col>
        </Row>
      </Modal.Body>

      <Modal.Footer>
        <CustomButton
          title="Fechar"
          onClick={onClose}
          color="#ff0000"
        >
          <XCircleFill />
        </CustomButton>

        <CustomButton
          title="Salvar Alterações"
          onClick={handleSave}
          color="#198754"
          isLoading={isRequestUpdateInventoryLoading}
          isLoadingText="Salvando..."
        >
          <CheckCircleFill />
        </CustomButton>
      </Modal.Footer>
    </Modal>
  )
}
